import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { FORM_FIELDS } from "../../Constants";
import { Button } from "react-bootstrap";
import paginationFactory from "react-bootstrap-table2-paginator";

const PriceListTable = ({
  setFormData,
  invalidRows,
  setInvalidRows,
  priceListTableData,
  setPriceListTableData,
}) => {
  const { STORE_DATA } = FORM_FIELDS;
  const { PRICE_LIST_DATA } = STORE_DATA;

  const rowClasses = (row, rowIndex) => {
    if (invalidRows?.[rowIndex]) return "invalid-record";
  };

  const columns = [
    {
      dataField: PRICE_LIST_DATA.NAME.name,
      text: PRICE_LIST_DATA.NAME.title,
    },
    {
      dataField: PRICE_LIST_DATA.CODE.name,
      text: PRICE_LIST_DATA.CODE.title,
    },
    {
      dataField: PRICE_LIST_DATA.BAR_CODE.name,
      text: PRICE_LIST_DATA.BAR_CODE.title,
    },
    {
      dataField: PRICE_LIST_DATA.DESCRIPTION.name,
      text: PRICE_LIST_DATA.DESCRIPTION.title,
    },
    {
      dataField: PRICE_LIST_DATA.IS_SERVICE.name,
      text: PRICE_LIST_DATA.IS_SERVICE.title,
    },
    {
      dataField: PRICE_LIST_DATA.UNIT_OF_MEASURE.name,
      text: PRICE_LIST_DATA.UNIT_OF_MEASURE.title,
    },
    {
      dataField: PRICE_LIST_DATA.TAX_RATE.name,
      text: PRICE_LIST_DATA.TAX_RATE.title,
    },
    {
      dataField: PRICE_LIST_DATA.ITEM_GROUP.name,
      text: PRICE_LIST_DATA.ITEM_GROUP.title,
    },
    {
      dataField: PRICE_LIST_DATA.PN.name,
      text: PRICE_LIST_DATA.PN.title,
    },
    {
      dataField: PRICE_LIST_DATA.PRICE.name,
      text: PRICE_LIST_DATA.PRICE.title,
    },
    {
      dataField: PRICE_LIST_DATA.PP.name,
      text: PRICE_LIST_DATA.PP.title,
    },
  ];

  return (
    <fieldset className="scheduler-border">
      {setFormData && (
        <>
          <legend className="scheduler-border d-flex justify-content-between align-items-center">
            Cjenik
            {priceListTableData?.length > 0 && (
              <Button
                onClick={() => {
                  setPriceListTableData([]);
                  setFormData([]);
                  setInvalidRows({});
                }}
              >
                Izbriši cjenik
              </Button>
            )}
          </legend>

          {Object.keys(invalidRows)?.length > 0 && (
            <div className="invalid-record my-3 p-3">
              {Object.keys(invalidRows).map((x) => (
                <p key={x} className="m-0">
                  Redak {Number(x) + 1}:{" "}
                  {invalidRows[x].map((text, i) => (
                    <span key={i}>{text}, </span>
                  ))}
                </p>
              ))}
            </div>
          )}
        </>
      )}
      {priceListTableData?.length > 0 && (
        <>
          <BootstrapTable
            keyField={PRICE_LIST_DATA.ID.name}
            data={priceListTableData}
            rowClasses={rowClasses}
            columns={columns}
            noDataIndication={"Nema podataka"}
            pagination={paginationFactory()}
          />
        </>
      )}
    </fieldset>
  );
};

export default PriceListTable;
